
Vue.component("knowledge_course_card", {
    props: {
        item: {
            type: Object,
            required: true,
            default: () => ({})
        },
        show_tag: {
            type: Boolean,
            default: false
        }
    },
    methods: {


        handleClick(e) {
            e.preventDefault();
            if (this.item.type == 'teacher') {
                location.href = '/learn/knowledge/teacher?code=' + this.item.id;
                return
            }
            let href = `/learn/knowledge/video?id=${this.item.id || this.item.contentId_}`;
            if(this.item.type == 'knowledge') {
                href = href + '&name=' + this.item.name + '&createDate=' + this.item.createDate_;
            }
            location.href = encodeURI(href)
        }
    },
    template: `
<template>
    <a class="knowledge_course_card teacher" v-if="item.type == 'teacher'" @click="handleClick">
        <div class="cover_box">
            <div class="cover">
                <div v-if="show_tag" class="tag">老师</div>
                <img :src="item.cover" alt="">
            </div>
        </div>
        <div class="content_box">
            <div class="name">{{item.name}}</div>
        </div>
    </a>
    <a class="knowledge_course_card live" v-else-if="item.type == 'live'" @click="handleClick">
        <div class="cover_box">
            <div v-if="show_tag" class="tag">
                <iconfont type="iconzhibozhong"></iconfont>
                <span>直播中</span>
            </div>
            <img :src="item.liveCover" alt="">
            <div class="tool_bar">
                <div class="like">
                    <iconfont type="icondianzan"></iconfont>
                    <span>{{item.like || 0}}</span>
                </div>
            </div>
        </div>
        <div class="content_box">
            <div class="name">{{item.liveName}}</div>
            <div class="desc">{{item.liveSpeaker}}</div>
        </div>
    </a>
    <a class="knowledge_course_card course" v-else-if="item.type == 'course'" @click="handleClick">
        <div class="cover_box">
            <div v-if="show_tag" class="tag">课程</div>
            <img :src="item.cover" alt="">
            <div class="tool_bar">
                <div class="like">
                    <iconfont type="icondianzan"></iconfont>
                    <span>{{item.like || 0}}</span>
                </div>
            </div>
        </div>
        <div class="content_box">
            <div class="name">{{item.name_}}</div>
            <div class="desc">{{item.teacher_names.join(',')}}</div>
        </div>
    </a>
    <a class="knowledge_course_card knowledge" v-else-if="item.type == 'knowledge'" @click="handleClick">
        <div class="cover_box">
            <div v-if="show_tag" class="tag">知识点</div>
            <img :src="item.cover" alt="">
            <div class="tool_bar">
                <div class="like">
                    <iconfont type="icondianzan"></iconfont>
                    <span>{{item.like || 0}}</span>
                </div>
            </div>
        </div>
        <div class="content_box">
            <div class="name">{{item.name}}</div>
            <div class="desc">{{item.teacher}}</div>
        </div>
    </a>
</template>`
});